import { notifications } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";


interface MutationProps {
  patientId: string;
}

export const useGetMeetingToken = () => {
  return useMutation({
    mutationFn: ({ patientId }: MutationProps) => {
      // console.log("reason in query param", reason);
      return api.post(`appointments/callToken/${patientId}`);
    },

    onError: (res: any) => {
      console.error("[From Get Meeting Token]", res);
      notifications.show({
        title: "Error",
        message: res?.response?.data?.detail || res?.message,
        autoClose: false,
        color: "red",
      });
    },
  });
};
